/** How long to wait after page load before checking for a blank screen. */
export const BLANK_SCREEN_CHECK_DELAY_MS = 18_000

const APP_LOADING_PLACEHOLDER_ID = 'app-loading-placeholder'

const RENDERED_CONTENT_SELECTORS = [
	'.infoboard',
	'.pincode-page',
] as const

const RECOVERY_FLAG = '__infoboardBlankScreenRecovery'

declare global {
	interface Window {
		[RECOVERY_FLAG]?: boolean
	}
}

/** Returns true when the app has rendered a known view or any visible content. */
export function hasRenderedContent(): boolean {
	const unsupportedBrowser = document.getElementById('unsupported-browser')
	if (unsupportedBrowser && window.getComputedStyle(unsupportedBrowser).display !== 'none') {
		return true
	}

	if (document.getElementById(APP_LOADING_PLACEHOLDER_ID)) {
		return false
	}

	const app = document.getElementById('app')
	if (!app) {
		return false
	}

	for (const selector of RENDERED_CONTENT_SELECTORS) {
		if (app.querySelector(selector)) {
			return true
		}
	}

	const textContent = app.textContent?.trim() ?? ''
	if (textContent.length > 0) {
		return true
	}

	return app.children.length > 0
}

/**
 * Starts a one-shot timer that reloads the page when no content has rendered.
 * Safe to call more than once — only the first call schedules the check.
 */
export function startBlankScreenRecovery(): void {
	if (window[RECOVERY_FLAG]) {
		return
	}

	window[RECOVERY_FLAG] = true

	window.setTimeout(() => {
		if (hasRenderedContent()) {
			return
		}

		console.warn(
			`[infoboard] No content rendered after ${BLANK_SCREEN_CHECK_DELAY_MS}ms — reloading page`,
		)
		window.location.reload()
	}, BLANK_SCREEN_CHECK_DELAY_MS)
}
